import {DateTime} from 'luxon'
import {issueDateFormat} from '@/pages/issue/constants/issue-date-format'

const toJSDateFormat = (issueDate) => {
  return DateTime.fromFormat(issueDate, issueDateFormat).toJSDate()
}

const jsDateToFormat = (jsDate, format: string) => {
  return jsDate ? DateTime.fromJSDate(jsDate).toFormat(format) : ''
}

const getLocalTime = () => {
  return DateTime.local().toJSDate()
}

const validatePurchaseDate = (writeDate, purchaseDate) => {
  const writeDateToDateTime = DateTime.fromFormat(writeDate, issueDateFormat)
  const purchaseDateToDateTime = DateTime.fromFormat(purchaseDate, issueDateFormat)
  const writeDateYear = writeDateToDateTime.year
  const writeDateMonth = writeDateToDateTime.month
  const toDate = DateTime.local(writeDateYear, writeDateMonth)
  const diffDate = purchaseDateToDateTime.diff(writeDateToDateTime)
  if(diffDate.as('days') > 0) {
    return 'from-date-error'
  }
  if(purchaseDateToDateTime.diff(toDate).as('days') < 0) {
    return 'to-date-error'
  }
  return ''
}

export {toJSDateFormat, jsDateToFormat, getLocalTime, validatePurchaseDate}
